// Shared SPA lifecycle helper (plan A9): run a cleanup once an element leaves
// the DOM. The one place a MutationObserver lives — screens import this instead
// of rolling their own.

/** Run `cb` once `el` is removed from the DOM. If `el` is already detached when
 *  called (e.g. a superseded navigation discarded it), run the cleanup now
 *  rather than re-scheduling forever — otherwise the controller's engine /
 *  document listeners would outlive the tab. */
export function onDisconnect(el: HTMLElement, cb: () => void): void {
  const parent = el.parentElement;
  if (!parent) {
    cb();
    return;
  }
  const obs = new MutationObserver(() => {
    if (!el.isConnected) {
      obs.disconnect();
      cb();
    }
  });
  obs.observe(parent, { childList: true });
}
